const actions = {
    updateState: 'block/UPDATE_BLOCK',
    getRoomOwner: 'block/GET_ROOM_OWNER',
    createBlockDate: 'block/CREATE_BLOCK_DATE',
    getInitialState: 'block/GET_INITIAL_STATE',
    removeBlockDates: 'block/REMOVE_BLOCK_DATE',
    setState:'block/SET_STATE',
}

export default actions